export const MAIN_CONTRACT = 'account.info'

// export const MAIN_CONTRACT = 'metadatatptp'